export default __webpack_public_path__ + "static/media/a.8717d00f.png";